import React from 'react';
import { FaPython, FaReact, FaJsSquare, FaDocker, FaGitAlt, FaLinux, FaDatabase, FaJava, FaHtml5, FaCss3Alt, FaNodeJs } from 'react-icons/fa';
import { SiCplusplus, SiOpencv, SiQt, SiOpengl, SiPytorch, SiTensorflow, SiPostgresql, SiMysql, SiMongodb, SiTypescript, SiNextdotjs, SiVite, SiTailwindcss } from 'react-icons/si';
import { BsGpuCard } from 'react-icons/bs'; // Using GPU icon for CUDA

// Map technology names to icons
export const techIconMap = {
  'Python': <FaPython />,
  'C++': <SiCplusplus />,
  'CUDA': <BsGpuCard title="CUDA"/>, // Add title for clarity
  'OpenCV': <SiOpencv />,
  'Qt': <SiQt />,
  'OpenGL': <SiOpengl />,
  'PyTorch': <SiPytorch />,
  'TensorFlow': <SiTensorflow />,
  'React': <FaReact />,
  'JavaScript': <FaJsSquare />,
  'TypeScript': <SiTypescript />,
  'Node.js': <FaNodeJs />,
  'Next.js': <SiNextdotjs />,
  'Vite': <SiVite />,
  'HTML': <FaHtml5 />,
  'CSS': <FaCss3Alt />,
  'TailwindCSS': <SiTailwindcss />,
  'Docker': <FaDocker />,
  'Git': <FaGitAlt />,
  'Linux': <FaLinux />,
  'SQL': <FaDatabase />,
  'PostgreSQL': <SiPostgresql />,
  'MySQL': <SiMysql />,
  'MongoDB': <SiMongodb />,
  'Java': <FaJava />,
  // Add more mappings as needed
};
